import { Component } from '@angular/core';

@Component({
  selector: 'app-stock-actual-qty',
  standalone: false,
  
  templateUrl: './stock-actual-qty.component.html',
  styles: ``
})
export class StockActualQtyComponent {

}
